var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-dialog-manager"},_vm._l((_vm.openDialogs),function(dialog,i){return _c(dialog.component,_vm._g(_vm._b({key:i,tag:"component"},'component',dialog.dialogProps,false),dialog.dialogListeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }